<template>
  <validation-observer ref="observer">
    <form @submit.prevent="submit" v-if="shaft" class="pt-2">
      <validation-provider
        v-slot="{ errors }"
        name="cover"
        rules="required"
        mode="lazy"
      >
        <v-select
          v-model="shaft.cover"
          :items="coverChoices"
          :error-messages="errors"
          label="Schachtabdeckung *"
          data-vv-name="cover"
          item-text="type"
          return-object
          outlined
          color="grey darken-2"
          :disabled="shaft.ordered"
        >
          <template v-slot:item="{ item }">
            <div class="d-flex flex-column">
              <div>{{ item.type }}</div>
              <div class="caption">{{ item.group }} {{ item.subgroup }}</div>
            </div>
          </template>
        </v-select>
      </validation-provider>

      <validation-provider
        v-slot="{ errors }"
        name="top_edge"
        rules="required|decimal"
        mode="lazy"
      >
        <v-text-field
          v-model="shaft.top_edge"
          :error-messages="errors"
          label="Geländeoberkante *"
          suffix="m"
          outlined
          color="grey darken-2"
          :disabled="shaft.ordered"
        ></v-text-field>
      </validation-provider>

      <validation-provider
        v-slot="{ errors }"
        name="bottom_edge"
        rules="required|decimal"
        mode="lazy"
      >
        <v-text-field
          v-model="shaft.bottom_edge"
          :error-messages="errors"
          label="Gerinne Sohle *"
          suffix="m"
          outlined
          color="grey darken-2"
          :disabled="shaft.ordered"
        >
        </v-text-field>
      </validation-provider>

      <validation-provider
        v-slot="{ errors }"
        name="clamp"
        rules="required"
        mode="lazy"
      >
        <v-select
          v-model="shaft.clamp"
          :items="clampChoices"
          :error-messages="errors"
          label="Steigbügel *"
          data-vv-name="clamp"
          item-text="text"
          item-value="value"
          outlined
          color="grey darken-2"
          :disabled="shaft.ordered"
        >
        </v-select>
      </validation-provider>

      <validation-provider
        v-slot="{ errors }"
        name="material"
        rules="required"
        mode="lazy"
      >
        <v-select
          v-model="shaft.sealing"
          :items="sealingChoices"
          :error-messages="errors"
          label="Dichtung *"
          data-vv-name="sealing"
          item-text="text"
          item-value="value"
          outlined
          color="grey darken-2"
          :disabled="shaft.ordered || sealingChoices.length === 0"
        >
        </v-select>
      </validation-provider>

      <div class="my-4 text-center">
        <v-btn
          color="primary"
          class="text-center"
          type="submit"
          :loading="isSubmitting"
          outlined
        >
          Weiter
        </v-btn>
      </div>
    </form>
  </validation-observer>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'FormEditBuildup1',
  components: {},
  props: [
    'shaft',
    'coverChoices',
    'clampChoices',
    'coneChoices',
    'sealingChoices',
  ],
  data: () => ({
    isSubmitting: false,
  }),
  computed: {
    ...mapGetters([]),
  },
  watch: {
    shaft() {
      this.formatDecimals();
    },
  },
  created() {
    this.formatDecimals();
  },
  methods: {
    ...mapActions([
      'updateCurrentShaft',
      'createShaftBuildup',
      'setCurrentShaft',
    ]),
    submit() {
      this.$refs.observer.validate().then(async success => {
        if (!success) {
          return;
        }
        this.isSubmitting = true;
        try {
          if (!this.shaft.ordered) {
            await this.updateCurrentShaft(this.shaft);
            if (
              !this.shaft.cone ||
              !this.shaft.buildups ||
              this.shaft.buildups.length === 0
            )
              await this.createShaftBuildup(this.shaft);
          }
          this.$emit('submit');
        } catch {
          // ignored
        }
        this.isSubmitting = false;
      });
    },
    clear() {
      this.$refs.observer.reset();
    },
    formatDecimals() {
      if (!this.shaft) return;
      if (this.shaft.top_edge) {
        this.shaft.top_edge = ('' + this.shaft.top_edge).replace('.', ',');
      }
      if (this.shaft.bottom_edge) {
        this.shaft.bottom_edge = ('' + this.shaft.bottom_edge).replace(
          '.',
          ',',
        );
      }
    },
  },
};
</script>

<style scoped>
.form-switch {
  position: absolute;
  right: -7px;
}

.form-switch >>> .v-messages {
  display: none;
}
</style>
